import React from 'react';
import { Result, Button } from 'antd';
import { CloseCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface ErrorPageProps {
  title?: string;
  message?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ 
  title = 'Không tìm thấy dữ liệu',
  message = 'Link truy cập không hợp lệ hoặc đã hết hạn. Vui lòng liên hệ với chúng tôi để được hỗ trợ.'
}) => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <Result
        icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
        status="error"
        title={title}
        subTitle={message}
        extra={[
          <Button 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={() => window.location.href = '/'}
            key="home"
          >
            Về trang chủ
          </Button>,
        ]}
        style={{
          background: 'white',
          borderRadius: '8px',
          padding: '40px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }}
      />
    </div>
  );
};

export default ErrorPage;

